export default {
	baseStyle: {
		dialog: {
			background: 'linear-gradient(90deg,rgb(100, 71, 101) 0%,rgb(33, 74, 112) 100%)',
		},
	},
}